// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root,
:host {
    --gw-button-text-bg: var(--gw-lightgrey-bg);
    --gw-button-transition-duration: 0.15s;
    --gw-button-border-radius-sm: 8px;
    --gw-button-border-radius-md: 4px;
    --gw-button-border-radius-lg: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/themes/default/button.css"],"names":[],"mappings":"AAAA;;IAEI,2CAA2C;IAC3C,sCAAsC;IACtC,iCAAiC;IACjC,iCAAiC;IACjC,iCAAiC;AACrC","sourcesContent":[":root,\n:host {\n    --gw-button-text-bg: var(--gw-lightgrey-bg);\n    --gw-button-transition-duration: 0.15s;\n    --gw-button-border-radius-sm: 8px;\n    --gw-button-border-radius-md: 4px;\n    --gw-button-border-radius-lg: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
